import { ReactElement } from 'react';
import { ContactInformation } from '../../../ContactInformation';
import { DEFAULT_RESEARCH_EMAIL_ADDRESS } from '../../../ContactInformation/ContactInformation.constants';

const RequestAccessArticleContent = (): ReactElement => (
  <p>
    Please send us the term sheet and/or credit agreement for access to this private report. Documents can be sent to{' '}
    <ContactInformation
      showClientService={false}
      showAssignedAccountManager={false}
      emailAddress={DEFAULT_RESEARCH_EMAIL_ADDRESS}
    />
    .
  </p>
);

export default RequestAccessArticleContent;
